export const topics = [
  {
    slug: "2025-entertainment-topic-timeline",
    title: "2025 年度娱乐话题总盘点：从热搜到退潮的完整时间线",
    category: "年度盘点",
    categorySlug: "annual",
    year: 2025,
    rank: 1,
    heat: 98600,
    views: 128400,
    readTime: "9 分钟",
    publishedAt: "2025-08-18",
    author: "瓜田编辑部",
    tags: ["年度盘点", "话题复盘", "时间线"],
    summary:
      "把一整年的娱乐话题按季度铺开，从年初的舞台争议到年中的合约风波，再到年末的综艺名场面，一条时间线看清话题如何起、如何热、又如何退潮。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20pop%20art%20collage%20of%20stage%20spotlights%2C%20microphones%20and%20newspaper%20clippings%2C%20warm%20coral%20and%20amber%20tones%2C%20bold%20modern%20editorial%20poster%20style%2C%20no%20people%2C%20high%20detail&width=1200&height=800&seq=gt-annual-2025-main&orientation=landscape",
    highlights: [
      "全年话题大致分三波：舞台改编争议、合约与团队变动、综艺名场面。",
      "热度最高的两个节点都出现在季播综艺上线后的两周内。",
      "多数话题在 7 天左右达到讨论峰值，随后快速退潮。",
    ],
    sections: [
      {
        heading: "第一季度：舞台改编把话题拱上了热搜",
        paragraphs: [
          "年初的几档音乐类竞演节目几乎承包了整个季度的讨论。改编幅度较大的舞台，往往在播出当晚就会引发两派意见：一派认为勇于突破，另一派觉得脱离了原曲气质。这类讨论通常不涉及事实争议，更多是审美分歧，因此热度来得快、去得也快。",
          "值得注意的是，同一场舞台的讨论往往会经历「首播争议—片段二传—原曲被翻出来重听」三个阶段，最后话题会回落到音乐本身。这也是我们把它放在年度盘点开头的原因：它是一个很典型的话题生命周期样本。",
        ],
      },
      {
        heading: "第二季度：合约与团队变动成为讨论主线",
        paragraphs: [
          "进入第二季度，讨论重心从舞台转向了合作关系的变动。合约到期、团队重组、资源分配这类话题的复杂度更高，因为它牵扯到多方说法，且往往没有即时结论。我们在整理这类话题时，会优先标注每一方的公开回应时间，避免读者被截取片段带偏。",
          "与第一季度的审美分歧不同，这一阶段的讨论更考验信息源。建议补课时先看时间线，再看各方回应，最后再看评论，顺序反了很容易先入为主。",
        ],
      },
      {
        heading: "第三、四季度：综艺名场面接棒，讨论回归轻松",
        paragraphs: [
          "下半年讨论氛围明显轻快起来。几档慢综艺和团综贡献了大量名场面，从游戏翻车到临场救场，被剪进二创的片段一个接一个。这类内容的特点是传播性强、争议性低，非常适合当作补课的入口。",
          "到年末，讨论又回到年度总结本身：谁的话题度最高、哪些名场面被回放最多、哪些争议有了后续。这正是我们每年做年度盘点的意义——把散落的片段重新串起来。",
        ],
      },
    ],
    related: ["top-10-topic-heat-2025", "top-ten-moments-2025", "contract-season-cases"],
  },
  {
    slug: "top-ten-moments-2025",
    title: "年度十大高能名场面：那些被反复回放的瞬间",
    category: "名场面",
    categorySlug: "moment",
    year: 2025,
    rank: 2,
    heat: 91200,
    views: 117300,
    readTime: "7 分钟",
    publishedAt: "2025-08-15",
    author: "二创观察组",
    tags: ["名场面", "合集", "综艺"],
    summary:
      "从舞台救场到游戏翻车，从一句神来之笔到全场沉默的三秒，这十个瞬间是被二创回放最多的名场面，也是年度补课的捷径。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20theater%20stage%20with%20warm%20amber%20spotlights%20and%20empty%20microphone%20stand%2C%20dramatic%20lighting%2C%20coral%20and%20gold%20color%20palette%2C%20cinematic%20minimal%20composition%2C%20no%20people&width=1200&height=800&seq=gt-moments-ten&orientation=landscape",
    highlights: [
      "名场面的共同点是「三秒内能看懂」，不需要前情提要。",
      "舞台救场类片段平均回放量最高，其次是游戏翻车类。",
      "十个片段里有七个出自综艺，三个出自直播或舞台现场。",
    ],
    sections: [
      {
        heading: "什么是「名场面」：三秒定胜负",
        paragraphs: [
          "名场面和普通高光的区别在于信息密度。普通高光需要背景铺垫，而名场面往往三秒内就能让人看懂笑点或泪点，这也是它天然适合被剪辑成短视频的原因。",
          "在整理这类内容时，我们会刻意保留语境，避免把一句玩笑话剪成「冲突」。毕竟同一个片段，配不同的字幕，可以是喜剧，也可以是误会。",
        ],
      },
      {
        heading: "舞台类：救场与改编撑起半壁江山",
        paragraphs: [
          "舞台类名场面主要分两种：一种是临场救场，比如话筒故障、伴奏出错时的自然反应；另一种是改编带来的反差感，例如把抒情歌改成乐队版本后全场的欢呼。前者靠真实，后者靠创意。",
          "这类片段的回放寿命通常很长，因为它们不依赖时效，隔年再刷依然好笑。",
        ],
      },
      {
        heading: "综艺类：游戏翻车与临场反应",
        paragraphs: [
          "综艺贡献的名场面更密集。游戏环节的翻车、抢答时的口误、被队友背刺的瞬间，都是二创的高频素材。它们的共同点是「不可复制」，重来一次效果就没了。",
          "如果你时间有限，建议从这一栏开始补课，五分钟就能看完一整个快乐合集。",
        ],
      },
    ],
    related: ["variety-moments-annual", "2025-entertainment-topic-timeline", "top-10-topic-heat-2025"],
  },
  {
    slug: "top-10-topic-heat-2025",
    title: "TOP榜｜年度话题热度前十：谁撑起了全年的讨论量",
    category: "TOP榜",
    categorySlug: "top",
    year: 2025,
    rank: 3,
    heat: 88700,
    views: 104500,
    readTime: "8 分钟",
    publishedAt: "2025-08-11",
    author: "数据盘点组",
    tags: ["TOP榜", "热度", "年度"],
    summary:
      "用讨论量、回放量与二创数量三个维度排序，排出年度话题热度前十，并解释每一个话题为什么能热、热度又停在了哪里。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20data%20visualization%20of%20rising%20bar%20charts%20and%20ranking%20podium%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20clean%20editorial%20infographic%20style%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=gt-top10-chart&orientation=landscape",
    highlights: [
      "热度排序综合了讨论量、回放量与二创数量，避免单一指标失真。",
      "前十里有四个话题属于同一档节目，节目本身成了最大赢家。",
      "热度第一的话题全周期持续了 21 天，是平均值的 3 倍。",
    ],
    sections: [
      {
        heading: "榜单怎么排：三个维度加权",
        paragraphs: [
          "只看热搜次数容易失真，因为一次大事件可能带来大量重复讨论。我们采用讨论量、回放量与二创数量三个维度加权，其中二创数量权重最高，因为它更能反映话题的持续生命力。",
          "榜单不评价话题的对错，只呈现关注度分布，这也是我们做 TOP 榜一贯的原则。",
        ],
      },
      {
        heading: "榜首为什么能持续三周",
        paragraphs: [
          "热度第一的话题有一个其他话题没有的特点：它有持续的新信息进入。每隔几天就有新的公开回应或后续进展，让讨论不断被重新点燃，因此生命周期远长于平均水平。",
          "相比之下，第四到第十名的话题多为单点爆发，热度在三天内冲顶，随后迅速回落。",
        ],
      },
      {
        heading: "节目比话题更长尾",
        paragraphs: [
          "一个有意思的现象是，虽然具体话题会退潮，但产出这些话题的节目本身获得了长尾关注。前十话题中有四个来自同一档节目，等于给节目做了一次全年的免费宣传。",
          "对读者来说，记住节目比记住单个话题更有用，因为它帮你锚定了一整类内容的出处。",
        ],
      },
    ],
    related: ["2025-entertainment-topic-timeline", "contract-season-cases", "collection-top-ten-must-watch"],
  },
  {
    slug: "contract-season-cases",
    title: "经典案例复盘：合约风波为什么总在续约季出现",
    category: "经典案例",
    categorySlug: "case",
    year: 2025,
    rank: 4,
    heat: 76400,
    views: 88900,
    readTime: "10 分钟",
    publishedAt: "2025-08-06",
    author: "行业观察组",
    tags: ["经典案例", "合约", "行业观察"],
    summary:
      "把近年来几类典型的续约争议放在一起对比，从信息发布时间、双方表述差异到舆论走向，拆解这类话题为什么容易陷入各说各话。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20concept%20of%20signed%20contract%20documents%20and%20a%20balance%20scale%20on%20warm%20cream%20desk%2C%20muted%20plum%20and%20coral%20accents%2C%20clean%20editorial%20still%20life%2C%20no%20readable%20text%2C%20no%20people&width=1200&height=800&seq=gt-contract-case&orientation=landscape",
    highlights: [
      "续约争议的爆发点高度集中：多在原合约到期前 1-2 个月。",
      "双方表述差异通常集中在「是否提前沟通」这一个焦点上。",
      "缺少权威结论时，时间线比观点更能帮助读者判断。",
    ],
    sections: [
      {
        heading: "为什么集中在续约季",
        paragraphs: [
          "合约类争议有一个很像「季节性」的规律：多数集中在原合约到期前一两个月。原因是这个阶段各方都需要为下一步做安排，任何一方的动作都可能被外界解读为「已经决定」。",
          "理解了这个时间规律，就不会把每一条传闻都当成实锤，也会更耐心地等正式公告。",
        ],
      },
      {
        heading: "焦点往往只有一个",
        paragraphs: [
          "对比几起案例会发现，双方的说法差异其实高度收敛，大多集中在「是否提前沟通」这一点上。一方强调早已告知，另一方强调从未收到明确信息，剩下的分歧基本都是从这一点衍生出来的。",
          "这也是为什么我们在整理时，会优先把「谁在什么时候说了什么」列清楚，而不是急着总结谁对谁错。",
        ],
      },
      {
        heading: "给读者的补课建议",
        paragraphs: [
          "遇到这类话题，推荐按「看时间线 → 看各方原话 → 再看评论」的顺序补课。跳过前两步直接看评论，很容易被最情绪化的那条带偏。",
          "另外，任何涉及具体条款的内容，如果当事方没有公开，我们不会替它脑补细节，这也是我们内容原则里的一条。",
        ],
      },
    ],
    related: ["person-profile-rising-curve", "stage-adaptation-copyright", "2025-entertainment-topic-timeline"],
  },
  {
    slug: "person-profile-rising-curve",
    title: "人物志｜从素人到顶流：一条被放大的成长曲线",
    category: "人物志",
    categorySlug: "profile",
    year: 2025,
    rank: 5,
    heat: 69800,
    views: 81200,
    readTime: "9 分钟",
    publishedAt: "2025-08-02",
    author: "人物观察组",
    tags: ["人物志", "成长曲线", "复盘"],
    summary:
      "以一位在过去几年快速被大众认识的艺人为样本，梳理从素人阶段到高关注阶段的几个关键节点，看看一条成长曲线是怎样被舆论放大的。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20minimal%20portrait%20silhouette%20made%20of%20flowing%20gradient%20waves%20on%20cream%20background%2C%20coral%20and%20amber%20gradient%2C%20modern%20editorial%20illustration%2C%20faceless%2C%20no%20recognizable%20person&width=1200&height=800&seq=gt-profile-curve&orientation=landscape",
    highlights: [
      "成长曲线通常有三个台阶：被看见、被讨论、被定义。",
      "每个台阶都伴随一次「身份标签」的重新命名。",
      "热度上升期最容易被过度解读，也最需要保留完整语境。",
    ],
    sections: [
      {
        heading: "第一个台阶：被看见",
        paragraphs: [
          "几乎所有人的起点都相似——一个被大量转发的片段。这个片段可能来自舞台，也可能来自一段采访，它的作用是让观众第一次记住一个名字。",
          "从这个阶段开始，公开信息的数量会突然增加，但质量参差不齐，这也是我们做人物志时最难筛选的部分。",
        ],
      },
      {
        heading: "第二个台阶：被讨论",
        paragraphs: [
          "被看见之后进入被讨论的阶段。此时讨论的对象从作品慢慢转向个人，采访里的每句话都可能被反复引用。这个阶段最容易出现「一句话被拆成十种解读」的情况。",
          "我们在整理时会尽量保留完整的问答语境，因为脱离语境的结论往往和原意相差很远。",
        ],
      },
      {
        heading: "第三个台阶：被定义",
        paragraphs: [
          "当一个人开始被贴上固定的标签，「被定义」就发生了。标签有好有坏，但共同点是它会压缩一个人的复杂度，让后续的作品和表达都被放进同一个框架里评价。",
          "对读者来说，意识到标签的存在，是保持独立判断的第一步。",
        ],
      },
    ],
    related: ["contract-season-cases", "2024-year-in-review", "stage-adaptation-copyright"],
  },
  {
    slug: "stage-adaptation-copyright",
    title: "舞台争议大盘点：改编、翻唱与版权那些事",
    category: "经典案例",
    categorySlug: "case",
    year: 2025,
    rank: 6,
    heat: 64100,
    views: 74600,
    readTime: "8 分钟",
    publishedAt: "2025-07-28",
    author: "行业观察组",
    tags: ["舞台", "版权", "改编"],
    summary:
      "把改编和翻唱引发的争议归成三类，分别说明它们争的到底是不是同一件事，以及为什么「好听不好听」和「能不能这么改」是两个问题。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20music%20sheet%20and%20sound%20wave%20merge%20with%20stage%20light%20beams%2C%20amber%20and%20coral%20tones%20on%20cream%20paper%2C%20editorial%20concept%20art%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=gt-stage-copyright&orientation=landscape",
    highlights: [
      "争议大致分三类：改编尺度、署名与授权、以及传播边界。",
      "「好不好听」属于审美，「能不能这么改」属于规则，两者常被混在一起。",
      "授权信息是否公开，往往是争议能否平息的关键。",
    ],
    sections: [
      {
        heading: "第一类：改编尺度",
        paragraphs: [
          "改编尺度是最常见的争议来源。观众的分歧在于改编离原曲有多远才算「恰到好处」，这本质上是审美问题，没有标准答案。",
          "因此这类讨论往往最热闹也最没有结论，热度自然衰减得也快。",
        ],
      },
      {
        heading: "第二类：署名与授权",
        paragraphs: [
          "如果说改编尺度是审美问题，那么署名与授权就是规则问题。这部分有明确的对错边界，判断依据是是否获得了相应授权、署名是否完整。",
          "我们在整理这类内容时，会以节目组或版权方的公开说明为准，不采信任何未公开的内部消息。",
        ],
      },
      {
        heading: "第三类：传播边界",
        paragraphs: [
          "还有一类争议发生在传播环节，比如二创剪辑的使用范围。随着二创越来越普遍，这一类的讨论也在变多，但多数时候它以平台规则的形式出现，而不是公开论战。",
          "把这三类分开看，你会发现很多「骂战」其实双方说的根本不是同一件事。",
        ],
      },
    ],
    related: ["contract-season-cases", "variety-moments-annual", "top-ten-moments-2025"],
  },
  {
    slug: "collection-top-ten-must-watch",
    title: "合集整理｜年度最值得补课的十个话题",
    category: "合集整理",
    categorySlug: "collection",
    year: 2025,
    rank: 7,
    heat: 58900,
    views: 69400,
    readTime: "6 分钟",
    publishedAt: "2025-07-22",
    author: "瓜田编辑部",
    tags: ["合集整理", "补课清单", "入门"],
    summary:
      "如果你只有两个小时，看这十个话题就够了。按照「先轻松后复杂」的顺序排列，从名场面入门，再到争议复盘，最后收束于年度总结。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20stack%20of%20colorful%20magazines%20and%20playlist%20cards%20arranged%20neatly%2C%20coral%20amber%20plum%20palette%20on%20cream%20background%2C%20clean%20editorial%20flat%20lay%2C%20no%20readable%20text&width=1200&height=800&seq=gt-collection-ten&orientation=landscape",
    highlights: [
      "补课顺序建议：先名场面，再年度盘点，最后争议案例。",
      "每个话题控制在 10 分钟阅读量以内，适合碎片时间。",
      "合集按主题打包，比零散追热搜更容易建立整体印象。",
    ],
    sections: [
      {
        heading: "为什么需要一份补课顺序",
        paragraphs: [
          "很多读者不是没时间，而是不知道从哪看起。热搜是跳跃的，今天是舞台争议，明天是合约风波，缺乏上下文会越看越乱。",
          "所以这份合集刻意做了排序：先看轻松的名场面建立好感，再看年度盘点建立框架，最后再看争议案例补充细节。",
        ],
      },
      {
        heading: "半小时入门包",
        paragraphs: [
          "如果你只有半小时，建议只读「年度十大高能名场面」和「2025 年度娱乐话题总盘点」这两篇。前者给你快乐，后者给你结构，两者合起来能覆盖大部分社交场合的聊天内容。",
          "读完这两篇，你至少不会在别人聊到某个梗时一脸茫然。",
        ],
      },
      {
        heading: "两小时进阶包",
        paragraphs: [
          "如果有两小时，可以再加上合约风波和舞台版权两篇经典案例。这两篇会告诉你，很多看似激烈的争论，其实争的是规则而不是情绪。",
          "补课的目的不是站队，而是让你在看热闹之外，还能看懂门道。",
        ],
      },
    ],
    related: ["2025-entertainment-topic-timeline", "top-ten-moments-2025", "top-10-topic-heat-2025"],
  },
  {
    slug: "variety-moments-annual",
    title: "综艺名场面年鉴：被剪进二创的高光与翻车",
    category: "名场面",
    categorySlug: "moment",
    year: 2025,
    rank: 8,
    heat: 55300,
    views: 63800,
    readTime: "7 分钟",
    publishedAt: "2025-07-16",
    author: "二创观察组",
    tags: ["综艺", "名场面", "二创"],
    summary:
      "按综艺类型分类整理年度名场面：竞技类的极限翻盘、慢综艺的意外默契、团综的集体破防，看看不同节目是怎么贡献笑点与泪点的。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20studio%20set%20with%20empty%20chairs%2C%20softbox%20lights%20and%20colorful%20props%2C%20amber%20and%20plum%20tones%2C%20cozy%20editorial%20illustration%2C%20no%20people%2C%20no%20text&width=1200&height=800&seq=gt-variety-yearbook&orientation=landscape",
    highlights: [
      "竞技类名场面靠「反转」，慢综艺靠「真实反应」。",
      "团综的集体名场面最容易出圈，因为情绪浓度高。",
      "同一节目往往能贡献多个名场面，形成集群效应。",
    ],
    sections: [
      {
        heading: "竞技类：反转就是一切",
        paragraphs: [
          "竞技类节目的名场面几乎都建立在反转上：最后一秒的逆转、被低估者的爆发、全线崩盘后的力挽狂澜。观众记住的不是谁赢了，而是那个「没想到」的瞬间。",
          "这也是竞技类节目二创率最高的原因，反转天然适合做短视频的钩子。",
        ],
      },
      {
        heading: "慢综艺：真实反应最动人",
        paragraphs: [
          "慢综艺没有激烈的赛制，名场面往往来自一些很小的瞬间：一句无心的吐槽、一次默契的对视。它们之所以能出圈，是因为足够真实，不像设计好的桥段。",
          "这类片段的生命周期特别长，隔一年再看依然有温度。",
        ],
      },
      {
        heading: "团综：情绪浓度最高",
        paragraphs: [
          "团综的名场面常常是集体性的，一群人同时破防或同时大笑，情绪浓度远高于单人镜头。这种群像感让片段更容易传播，也更容易让新观众产生「想加入」的冲动。",
          "如果你想快速感受一档节目的氛围，看它的团综名场面剪辑是最快的办法。",
        ],
      },
    ],
    related: ["top-ten-moments-2025", "stage-adaptation-copyright", "collection-top-ten-must-watch"],
  },
  {
    slug: "2024-year-in-review",
    title: "2024 年度回顾：去年那些话题后来都怎么样了",
    category: "年度盘点",
    categorySlug: "annual",
    year: 2024,
    rank: 9,
    heat: 47200,
    views: 55600,
    readTime: "8 分钟",
    publishedAt: "2024-12-30",
    author: "瓜田编辑部",
    tags: ["年度盘点", "后续追踪", "2024"],
    summary:
      "时隔一年回头看，有些话题早已有了结论，有些则不了了之。这一篇专门做后续追踪，看看当时的热搜后来走向了哪里。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20retro%20timeline%20of%20paper%20cards%20and%20clock%20face%20on%20cream%20desk%2C%20muted%20amber%20and%20plum%20accents%2C%20editorial%20still%20life%2C%20no%20readable%20text%2C%20no%20people&width=1200&height=800&seq=gt-review-2024&orientation=landscape",
    highlights: [
      "去年的话题大致分三类结局：有正式结论、和平淡出、持续悬置。",
      "超过一半的话题在一年内失去了后续信息。",
      "有公开回应的争议，热度衰减明显更快。",
    ],
    sections: [
      {
        heading: "第一类：有了正式结论",
        paragraphs: [
          "少数话题最终等来了明确的公告或说明，争议随之平息。这类话题的共同点是当事方选择正面回应，而不是让讨论自然冷却。",
          "回应的速度很关键，越早给出说明，讨论越不容易被各种猜测填满。",
        ],
      },
      {
        heading: "第二类：和平淡出",
        paragraphs: [
          "更多话题的结局是淡出。没有公告，也没有争议升级，随着新的话题出现，公众注意力自然转移。这不是坏事，只是说明大部分娱乐话题的保质期确实有限。",
          "这也提醒我们，追热搜时不必太较真，很多事过几个月自己就给出了答案。",
        ],
      },
      {
        heading: "第三类：持续悬置",
        paragraphs: [
          "还有一类话题至今没有明确说法，双方都保持沉默。对这类内容，我们的处理方式是保留时间线、暂不下结论，并在有进展时更新原文。",
          "这一篇 2024 回顾会在有后续时持续补充，欢迎读者通过线索征集渠道告诉我们最新进展。",
        ],
      },
    ],
    related: ["2025-entertainment-topic-timeline", "contract-season-cases", "person-profile-rising-curve"],
  },
];